export default __webpack_public_path__ + "static/media/wizard2.956b6f78.png";